import React, { useState,useEffect } from "react";

import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectDateOnly from "../components/popups/SelectDateOnly";
import { ChangeDateFormat, addThousandPoint,ChangeMobileFormat,PassedMonthsCode,ToggleDarkBackground,DisplayOptionString,
        GetSimpleDateTimeFromJDateTime,GetPaymentClassStatus,GetPaymentStatus,LoginAfterCheckLogin, 
        isObjEmpty} from "../../components/common/Common";
import centerIcon from "../../img/icon/icon-center-class-03.svg";
import "../../css/style.css";

//매출리포트
const SalesReport = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varClassList,setClassList] = useState([]);
  const classInfo = {cl_idx:0,cl_name:'전체 클래스'};
  const [varClassInfo,setClassInfo] = useState({});

  const [varPaymentsList,setPaymentsList] = useState([]);
  const [varSearchOptions,setSearchOptions] = useState({});
  const [varSelectOptions,setSelectOptions] = useState({});

  //클래스 관리
  const GetClassList = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_class_only_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      setClassList(datas.classes);
    });
  }

  //매출 정보 목록
  const GetPaymentList = async(options) => {
    const sendData = {branch_idx:branch_idx,cl_idx:varClassInfo.cl_idx,searchInfo:options};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_sales_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        let payments = datas.results;
        setPaymentsList(payments);
        let tsales = 0;
        for(var i=0; i<payments.length; i++) {
          tsales += payments[i].ph_price;
        }
        setSearchOptions({...varSearchOptions,terms:options.terms,sdate:options.sdate,edate:options.edate,tsales:tsales});
      } else {
        setSearchOptions({...varSearchOptions,terms:options.terms,sdate:options.sdate,edate:options.edate,tsales:0});
        setPaymentsList([]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    setBranchMenus({showMenu:true,gotoMain:1});
    console.log(varBranchMenus);

    const searchObj = {sdate:null,edate:null,terms:0,tsales:0};
    setSearchOptions(searchObj);
    setSelectOptions(searchObj);

    setClassInfo(classInfo);
    GetClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(!isObjEmpty(varClassInfo)) GetPaymentList(varSearchOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassInfo]);

  //클래스 선택
  const onChangeClassHandler = (e) => {
    const idx = Number(e.currentTarget.value);
    //선택된 클래스명
    if(idx > 0) {
      const classData = varClassList.find(el=>el.cl_idx === idx);
      setClassInfo(classData);
    } else {
      setClassInfo(classInfo);
    }
  }

  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    let options = {...varSearchOptions};
    options.terms = varSelectOptions.terms;
    options.sdate = varSelectOptions.sdate;
    options.edate = varSelectOptions.edate;
    GetPaymentList(options);
  }

  //검색기간 선택
  const onSelectTermHandler = (e,inum) => {
    const buttonBoxes = document.querySelectorAll('.btn-wrap > button');
    for(let i = 0; i < buttonBoxes.length; i++) {
      if(i === inum-1) {
        if(!buttonBoxes[i].classList.contains('on')) buttonBoxes[i].classList.add('on');
      } else {
        if(buttonBoxes[i].classList.contains('on')) buttonBoxes[i].classList.remove('on')
      }
    }
    let sdate = new Date();
    if(inum === 2) sdate.setDate(sdate.getDate() - 7);
    else if(inum === 3) sdate.setMonth(sdate.getMonth() - 1);   
    else if(inum === 4) sdate.setFullYear(sdate.getFullYear() - 1); 
    if(inum >= 2) sdate.setDate(sdate.getDate() + 1); 
    const edate = new Date();
    setSelectOptions({...varSelectOptions,terms:inum,sdate:ChangeDateFormat(sdate),edate:ChangeDateFormat(edate)});
  }

  //날짜선택 팝업창--------------------------------------------------------------------------------------
  const [varPopupDaySelect,setPopupDaySelect] = useState(false);  //팝업창 열기/닫기
  const [varDate,setDate] = useState(null); //선택된 날짜
  const [varStudyIndex,setStudyIndex] = useState(0); 
  const onChangeDateHandler = (e,imode) => {
    setStudyIndex(imode);
    let csdate = "";
    if(imode === 0) csdate = varSearchOptions.sdate;
    else csdate = varSearchOptions.edate;
    const sdate = new Date(csdate);
    setDate(sdate);
    //팝업창 위치조정
    /* const hasbtns = document.querySelectorAll('.cal-btn');
    const toppos = hasbtns[imode];
    const offsetY = window.pageYOffset+toppos.getBoundingClientRect().top - 100;
    const popupWin = document.querySelector('.layer-pop-select-date');
    popupWin.setAttribute('style',`top:${offsetY}px`); */
    //팝업창 호출
    TogglePopupDaySelect(true);
  }
  //팝업창 - 날짜 설정값 저장
  const ChangedDate = (date,imode) => {
    if(date === "" ) date = null;
    console.log(date,imode);
    const ndate = ChangeDateFormat(date);
    if(imode === 0) setSearchOptions({...varSearchOptions,sdate:ndate});
    else setSearchOptions({...varSearchOptions,edate:ndate});
    //팝업창 닫기
    TogglePopupDaySelect(false);
  }
  //팝업창 열기/닫기
  const TogglePopupDaySelect = (bmode) => {
    setPopupDaySelect(bmode);
    ToggleDarkBackground(bmode);
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'매출 리포트'} varBackString={'none'}/>
      <div className="vh-content-body">
        <div className="payment-wrap report-wrap">
          <div className="center-wrap">
            <div className="select-wrap">
							<label>클래스 선택</label>
							<select className="" name="cl_idx" value={varClassInfo.cl_idx} onChange={e=>onChangeClassHandler(e)}>
								<option value={0}>전체 클래스</option>
                {varClassList.map((classes,i)=>(
                  <option key={'classes_'+i} value={classes.cl_idx}>{classes.cl_name}</option>
                ))}
							</select>
						</div>
            <div className="search-wrap st02">
              <div className="btn-wrap">
								<button onClick={e=>onSelectTermHandler(e,1)}>일별</button>
								<button onClick={e=>onSelectTermHandler(e,2)}>주간</button>
								<button onClick={e=>onSelectTermHandler(e,3)}>월간</button>
								<button onClick={e=>onSelectTermHandler(e,4)}>연간</button>
							</div>
              <div className="flex">
								<p>기간</p>
                <div className="has-btn">
                  <input type="text" name="sdate" className="input-cal" value={varSelectOptions.sdate||""} placeholder="검색시작일" readOnly/>
									<button className="cal-btn" onClick={e=>onChangeDateHandler(e,0)}><img src={centerIcon} alt=""/></button>
								</div>
                -
                <div className="has-btn">
                  <input type="text" name="edate" className="input-cal" value={varSelectOptions.edate||""} placeholder="검색종료일" readOnly/>
									<button className="cal-btn" onClick={e=>onChangeDateHandler(e,1)}><img src={centerIcon} alt=""/></button>
								</div>
              </div>
            </div>
            <button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
            {/* 매출내역 */}
            <div className="search-ok-con">
              {/* 현재 조건에 대한 총 매출 */}
              <div className="top-box">
								<div className="flex">
									<p>클래스</p>
									<div>{varClassInfo.cl_name}</div>
								</div>
								<div className="flex">
									<p>기간</p>
									<div>{DisplayOptionString(varSearchOptions)}</div>
								</div>
								<div className="flex">
									<p>총 매출</p>
									<div>{addThousandPoint(varSearchOptions.tsales)}원</div>
								</div>
							</div>
              {/* 조건에 따른 매출내역 */}
              {varPaymentsList.map((payments,i)=>(
                <div key={'payments_'+i} className="con-box" >
                  <div className="txt-box">
                    <div className="date-line">
                      <div className="date">{GetSimpleDateTimeFromJDateTime(payments.ph_rdate)}</div>
                      <p className="price">₩ {addThousandPoint(payments.ph_price)} 원</p>
                    </div>
                    <div className="info-line">{payments.mem_name}&nbsp;&nbsp;{ChangeMobileFormat(payments.mem_mobile)} 
                      <span> 👼🏻[{payments.ch_name}({PassedMonthsCode(payments.ch_birthday)})]</span>
                    </div>
                    <div className="flex">
                      <p>결제 유형</p><div>{payments.ph_method===1?"카드":"현금"}</div>
                    </div>
                    <div className="flex">
                      <p>결제 학기</p><div>{payments.sm_name}</div>
                    </div>
                    <div className="flex">
                      <p>결제 클래스</p><div>{payments.cl_name}</div>
                    </div>
                    <div className="flex">
                      <p>청구서 ID</p>
                      <div>{payments.ivc_id}</div>
                    </div>
                    <div className="flex">
                      <p>결제 상태</p>
                      <div className={GetPaymentClassStatus(payments.ph_status)}>{GetPaymentStatus(payments.ph_status)}</div> 
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <SelectDateOnly varStudyIndex={varStudyIndex} varDate={varDate} setDate={setDate} varPopupDaySelect={varPopupDaySelect} 
                        TogglePopupDaySelect={TogglePopupDaySelect} ChangedDate={ChangedDate}/>
    </div>	
  );
}
export default SalesReport;